import { render, staticRenderFns } from "./zhongyi.vue?vue&type=template&id=1111ae9f&scoped=true&"
import script from "./zhongyi.vue?vue&type=script&lang=ts&"
export * from "./zhongyi.vue?vue&type=script&lang=ts&"
import style0 from "./zhongyi.vue?vue&type=style&index=0&id=1111ae9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111ae9f",
  null
  
)

export default component.exports